/** @jsx jsx */

import React, { Fragment as _, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext } from './interactionContext';
import EditableBtn from '../EditableBtn';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import getBlockById from 'services/apiHelpers/getBlockById';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import { State } from 'store/store';
import { Block } from 'factories/block';
import { useSelector, useDispatch } from 'react-redux';
import { updateAssessmentAction } from 'actions/updateAssessmentAction';

const FeedbackPassed = ({ children, ...props }) => {
  const context = useContext(interactionContext) as any;

  const [img, txt, btn] = children;

  return (
    <div
      css={css({
        width: '100%',
      })}
    >
      {txt}
    </div>
  );
};

export default FeedbackPassed;
